var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    { attrs: { height: 300, preserveAspectRatio: "none" } },
    [
      _c("rect", {
        attrs: {
          x: "0",
          y: "20",
          rx: "4",
          ry: "4",
          width: "200",
          height: "180"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "210",
          y: "40",
          rx: "4",
          ry: "4",
          width: "150",
          height: "20"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "210",
          y: "80",
          rx: "4",
          ry: "4",
          width: "180",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "210",
          y: "100",
          rx: "4",
          ry: "4",
          width: "180",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "210",
          y: "120",
          rx: "4",
          ry: "4",
          width: "180",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "230",
          rx: "4",
          ry: "4",
          width: "190",
          height: "40"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "210",
          y: "230",
          rx: "4",
          ry: "4",
          width: "180",
          height: "40"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d89234ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d89234ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/news/NewsLoadingSkeleton.vue
// module id = null
// module chunks = 